var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input',_vm._b({attrs:{"value":_vm.displayValue,"placeholder":_vm.placeholder},on:{"input":_vm.handleInput,"focus":_vm.handleFocus,"blur":_vm.handleBlur},scopedSlots:_vm._u([_vm._l((_vm.$slots),function(_,name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'el-input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }